import { useRef, useState } from "react";
import ErrorModal from "./UI/ErrorModal";
import classes from "./PersonaliaForm.module.css";

const PersonaliaForm = (props) => {
  const [isVoornaamValid, setIsVoornaamValid] = useState(true);
  const [isAchternaamValid, setIsAchternaamValid] = useState(true);
  const [error, setError] = useState("");

  const voornaamRef = useRef();
  const achternaamRef = useRef();
  const emailRef = useRef();
  const mobielRef = useRef();
  const geboortedatumRef = useRef();
  const geboorteplaatsRef = useRef();
  const straatRef = useRef();
  const huisnummerRef = useRef();
  const postcodeRef = useRef();
  const woonplaatsRef = useRef();
  const voorlettersRef = useRef();
  const tussenvoegselRef = useRef();
  const telefoonRef = useRef();
  const websiteRef = useRef();
  const geslachtRef = useRef();
  const landRef = useRef();
  const overigRef = useRef();

  const submitHandler = (event) => {
    event.preventDefault();

    if (voornaamRef.current.value.trim().length === 0) {
      setIsVoornaamValid(false);
      setError({
        title: "Voornaam mag niet leeg zijn",
        message: "Vul een geldige voornaam in",
      });
      return;
    }

    if (achternaamRef.current.value.trim().length === 0) {
      setIsAchternaamValid(false);
      setError({
        title: "Achternaam mag niet leeg zijn",
        message: "Vul een geldige achternaam in",
      });
      return;
    }

    const PersonaliaData = {
      voornaam: voornaamRef.current.value,
      achternaam: achternaamRef.current.value,
      email: emailRef.current.value,
      mobiel: mobielRef.current.value,
      geboortedatum: geboortedatumRef.current.value,
      geboorteplaats: geboorteplaatsRef.current.value,
      straat: straatRef.current.value,
      huisnummer: huisnummerRef.current.value,
      postcode: postcodeRef.current.value,
      woonplaats: woonplaatsRef.current.value,
      voorletters: voorlettersRef.current.value,
      tussenvoegsel: tussenvoegselRef.current.value,
      telefoon: telefoonRef.current.value,
      website: websiteRef.current.value,
      geslacht: geslachtRef.current.value,
      land: landRef.current.value,
      overig: overigRef.current.value,
    };

    console.log(PersonaliaData);
    props.onAddPersonalia(PersonaliaData);

    voornaamRef.current.value = "";
    achternaamRef.current.value = "";
    emailRef.current.value = "";
    mobielRef.current.value = "";
    geboortedatumRef.current.value = "";
    geboorteplaatsRef.current.value = "";
    straatRef.current.value = "";
    huisnummerRef.current.value = "";
    postcodeRef.current.value = "";
    woonplaatsRef.current.value = "";
    voorlettersRef.current.value = "";
    tussenvoegselRef.current.value = "";
    telefoonRef.current.value = "";
    websiteRef.current.value = "";
    geslachtRef.current.value = "";
    landRef.current.value = "";
    overigRef.current.value = "";
  };

  const voornaamChangeHandler = (event) => {
    if (event.target.value.trim().length > 0) {
      setIsVoornaamValid(true);
    }
  };

  const achternaamChangeHandler = (event) => {
    if (event.target.value.trim().length > 0) {
      setIsAchternaamValid(true);
    }
  };

  const confirmVoornaamHandler = () => {
    setIsVoornaamValid(true);
    setError("");
  };

  const confirmAchternaamHandler = () => {
    setIsAchternaamValid(true);
    setError("");
  };

  return (
    <form onSubmit={submitHandler}>
      <div className={classes["control-group"]}>
        <div
          className={`${classes["form-control"]} ${
            !isVoornaamValid && classes.invalid
          }`}
        >
          <label htmlFor="voornaam">Voornaam</label>
          <input
            type="text"
            id="voornaam"
            ref={voornaamRef}
            onChange={voornaamChangeHandler}
          />
          {!isVoornaamValid && (
            <ErrorModal
              title={error.title}
              message={error.message}
              onConfirm={confirmVoornaamHandler}
            />
          )}
        </div>
        <div
          className={`${classes["form-control"]} ${
            !isAchternaamValid && classes.invalid
          }`}
        >
          <label htmlFor="achternaam">Achternaam</label>
          <input
            type="text"
            id="achternaam"
            ref={achternaamRef}
            onChange={achternaamChangeHandler}
          />
          {!isAchternaamValid && (
            <ErrorModal
              title={error.title}
              message={error.message}
              onConfirm={confirmAchternaamHandler}
            />
          )}
        </div>
      </div>

      <div className={classes["control-group"]}>
        <div className={classes["form-control"]}>
          <label htmlFor="voorletters">Voorletters</label>
          <input type="text" id="voorletters" ref={voorlettersRef} />
        </div>
        <div className={classes["form-control"]}>
          <label htmlFor="tussenvoegsel">Tussenvoegsel</label>
          <input type="text" id="tussenvoegsel" ref={tussenvoegselRef} />
        </div>
      </div>

      <div className={classes["control-group"]}>
        <div className={classes["form-control"]}>
          <label htmlFor="email">Email Adres</label>
          <input type="email" id="email" ref={emailRef} />
        </div>
        <div className={classes["form-control"]}>
          <label htmlFor="mobiel">Mobiel Nummer</label>
          <input type="tel" id="mobiel" ref={mobielRef} />
        </div>
      </div>

      <div className={classes["control-group"]}>
        <div className={classes["form-control"]}>
          <label htmlFor="telefoon">Telefoon</label>
          <input type="tel" id="telefoon" ref={telefoonRef} />
        </div>
        <div className={classes["form-control"]}>
          <label htmlFor="website">Website</label>
          <input type="url" id="website" ref={websiteRef} />
        </div>
      </div>

      <div className={classes["control-group"]}>
        <div className={classes["form-control"]}>
          <label htmlFor="geboortedatum">Geboortedatum</label>
          <input type="date" id="geboortedatum" ref={geboortedatumRef} />
        </div>
        <div className={classes["form-control"]}>
          <label htmlFor="geboorteplaats">Geboorteplaats</label>
          <input type="text" id="geboorteplaats" ref={geboorteplaatsRef} />
        </div>
      </div>

      <div className={classes["control-group"]}>
        <div className={classes["form-control"]}>
          <label htmlFor="straat">Straat</label>
          <input type="text" id="straat" ref={straatRef} />
        </div>
        <div className={classes["form-control"]}>
          <label htmlFor="huisnummer">Huisnummer</label>
          <input type="text" id="huisnummer" ref={huisnummerRef} />
        </div>
      </div>

      <div className={classes["control-group"]}>
        <div className={classes["form-control"]}>
          <label htmlFor="postcode">Postcode</label>
          <input type="text" id="postcode" ref={postcodeRef} />
        </div>
        <div className={classes["form-control"]}>
          <label htmlFor="woonplaats">Woonplaats</label>
          <input type="text" id="woonplaats" ref={woonplaatsRef} />
        </div>
      </div>

      <div className={classes["control-group"]}>
        <div className={classes["form-control"]}>
          <label htmlFor="geslacht">Geslacht</label>
          <select name="geslacht" id="geslacht" ref={geslachtRef}>
            <option defaultValue="selected" value=""></option>
            <option value="Man">Man</option>
            <option value="Vrouw">Vrouw</option>
            <option value="Non-binair">Non-binair</option>
          </select>
        </div>
        <div className={classes["form-control"]}>
          <label htmlFor="land">Land</label>
          <input type="text" id="land" defaultValue="Nederland" ref={landRef} />
        </div>
      </div>

      <div className={classes["control-group"]}>
        <div className={classes["form-control"]}>
          <label htmlFor="overig">Overig</label>
          <textarea rows="5" id="overig" ref={overigRef}></textarea>
        </div>
      </div>

      <div className={classes["form-actions"]}>
        <button>Verzenden</button>
      </div>
    </form>
  );
};

export default PersonaliaForm;
